import "./404.css";

export const NotFound = () => {
  return (
    <div className="notFound">
      <div class="rail">
        <div class="stamp four">4</div>

        <div class="stamp zero">0</div>

        <div class="stamp four">4</div>

        <div class="stamp zero">0</div>

        <div class="stamp four">4</div>

        <div class="stamp zero">0</div>

        <div class="stamp four">4</div>

        <div class="stamp zero">0</div>

        <div class="stamp four">4</div>

        <div class="stamp zero">0</div>

        <div class="stamp four">4</div>

        <div class="stamp zero">0</div>

        <div class="stamp four">4</div>

        <div class="stamp zero">0</div>

        <div class="stamp four">4</div>

        <div class="stamp zero">0</div>

        <div class="stamp four">4</div>

        <div class="stamp zero">0</div>

        <div class="stamp four">4</div>

        <div class="stamp zero">0</div>
      </div>

      <div class="world">
        <div class="forward">
          <div class="box">
            <div class="wall"></div>

            <div class="wall"></div>

            <div class="wall"></div>

            <div class="wall"></div>

            <div class="wall"></div>

            <div class="wall"></div>
          </div>
        </div>
        <h1> Not Found </h1>
      </div>
    </div>
  );
};
